import {AContent, AContentDTO} from "../base.content";
import {CMSContentType} from "../CMSType";

export interface ICoordinates {
  lat: number;
  lng: number;
}

export interface MapContentParams extends ICoordinates{

}

export interface MapContentDTO extends AContentDTO {
  lat: number;
  lon: number;
}

const defaultCoordinates: MapContentParams = {lat: 0, lng: 0};

export class MapContent extends AContent {
  public readonly lat: number;
  public readonly lng: number;

  constructor(params: MapContentParams = defaultCoordinates) {
    super(CMSContentType.map);
    this.lat = params.lat;
    this.lng = params.lng;
  }

  setCoordinates(coordinates: ICoordinates): this {
    return this._merge({
      lng: coordinates.lng,
      lat: coordinates.lat,
    })
  }

  public toJSON() {
    return {
      ...super.toJSON(),
      lng: this.lng,
      lat: this.lat,
    };
  }
}



// WEBPACK FOOTER //
// ./src/api/club-cms/content/map.content.ts